import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { PresentationComponent } from './presentation/presentation.component';
import { ComponentsComponent } from './components/components.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { SupportComponent } from './pages/support/support.component';
import { LoginComponent } from './pages/login/login.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { SystemStatusComponent } from './pages/system-status/system-status.component';
import { InfoPopiComponent } from './pages/info-popi/info-popi.component';
import { InfoNewsComponent } from './pages/info-news/info-news.component';
import { InfoNewsDetailComponent } from './pages/info-news-detail/info-news-detail.component';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { DeveloperStatusComponent } from './pages/developer-status/developer-status.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { Page404Component } from './pages/page404/page404.component';
import { ReferralsComponent } from './pages/referrals/referrals.component';
import { GetAQuoteComponent } from './pages/get-a-quote/get-a-quote.component';
import { DiyComponent } from './pages/packages/diy/diy.component';
import { DiyStarterComponent } from './pages/packages/diy-starter/diy-starter.component';
import { FullHouseComponent } from './pages/packages/full-house/full-house.component';
import { EBuroComponent } from './pages/packages/e-buro/e-buro.component';
import { FeaturesComponent } from './pages/features/features.component';
import { TestimonialDetailComponent } from './pages/testimonial-detail/testimonial-detail.component';

const routes: Routes = [
    { path: 'presentation', component: PresentationComponent },
    { path: 'presentation/#ref_pms', component: PresentationComponent },
    { path: 'presentation/#ref_cn', component: PresentationComponent },
    { path: 'presentation/#ref_pack', component: PresentationComponent },

    { path: 'features', component: FeaturesComponent },
    { path: 'features/#ref_pms', component: FeaturesComponent },
    { path: 'features/#ref_cn', component: FeaturesComponent },



    { path: 'components', component: ComponentsComponent },
    { path: 'get-a-quote', component: GetAQuoteComponent },
    { path: 'get-a-quote/:type', component: GetAQuoteComponent },
    { path: 'packages/diy', component: DiyComponent },
    { path: 'packages/diy-starter', component: DiyStarterComponent },
    { path: 'packages/full-house', component: FullHouseComponent },
    { path: 'packages/e-buro', component: EBuroComponent },
    { path: 'contact_us', component: ContactUsComponent },
    { path: 'contact_us/:type/:data', component: ContactUsComponent },
    { path: 'referral/:practice_number/:email', component: ReferralsComponent },
    { path: 'referral', component: ReferralsComponent },
    { path: 'support', component: SupportComponent },
    { path: 'login', component: LoginComponent },
    { path: 'system_status', component: SystemStatusComponent },
    { path: 'developer_status', component: DeveloperStatusComponent },
    { path: 'info_popi', component: InfoPopiComponent },
    { path: 'info_news', component: InfoNewsComponent },
    { path: 'info_news_detail/:_id', component: InfoNewsDetailComponent },
    { path: 'testimonial_detail/:_id', component: TestimonialDetailComponent },
    { path: 'reset_password/:user_id', component: ResetPasswordComponent },
    { path: 'tandc', component: TermsAndConditionsComponent },
    { path: 'pp', component: PrivacyPolicyComponent },
    { path: '', component: PresentationComponent },
    { path: '#ref_pms', component: PresentationComponent },
    { path: '#ref_cn', component: PresentationComponent },
    { path: '#ref_pack', component: PresentationComponent },
    { path: "**", component: Page404Component }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, {
            useHash: false
        })
    ],
    exports: [
    ],
})
export class AppRoutingModule { }
